import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties';
import { type AccountId, toBaseUrl } from '@atlassian/jira-shared-types';

import { PANEL_STATE_KEY } from '../../../constants';
import type { PanelState, StoreActions } from '../../types';

export const setPanelState =
	(panelState: PanelState, atlassianAccountId: AccountId | null) =>
	async ({ setState, getState }: StoreActions) => {
		setState({ ...getState(), panelState });
		if (atlassianAccountId) {
			try {
				await setUserProperties(
					toBaseUrl(''),
					atlassianAccountId,
					PANEL_STATE_KEY,
					JSON.stringify(panelState),
				);
			} catch (error) {
				// Fire error analytics event here
			}
		}
	};
